import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  InputAdornment,
  TextField,
} from "@mui/material";
import { CalendarToday } from "@mui/icons-material";
import moment from "dayjs";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./styles.css";

const DateTimePicker = ({
  label,
  selectedDate,
  onChange,
  required,
  disabled,
}) => {
  const [isPickerOpen, setIsPickerOpen] = useState(false);

  const handleDateTimeChange = (date) => {
    if (date) {
      onChange(date);
    } else {
      onChange("");
    }
  };

  return (
    <>
      <TextField
        type="text"
        required={required || false}
        size="medium"
        label={label}
        value={
          selectedDate ? moment(selectedDate).format("MM-DD-YYYY h:mm A") : ""
        }
        variant="outlined"
        disabled={disabled || false}
        className="mb-3"
        fullWidth
        onClick={() => setIsPickerOpen(true)}
        onFocus={(e) => {
          e.currentTarget.blur();
        }}
        slotProps={{ input: {
          endAdornment: (
            <InputAdornment position="end">
              <CalendarToday />
            </InputAdornment>
          ),
        } }}
      />

      <Dialog open={isPickerOpen} onClose={() => setIsPickerOpen(false)}>
        <DialogContent>
          <ReactDatePicker
            selected={selectedDate ? new Date(selectedDate) : null}
            onChange={handleDateTimeChange}
            showTimeSelect
            timeFormat="HH:mm"
            timeIntervals={1}
            timeCaption="Time"
            dateFormat="MMMM d, yyyy h:mm aa"
            minDate={new Date()}
            inline
          />
        </DialogContent>
        <DialogActions
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Button
            variant="outlined"
            color="primary"
            onClick={() => {
              onChange("");
              setIsPickerOpen(false);
            }}
          >
            Clear
          </Button>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setIsPickerOpen(false)}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DateTimePicker;
